import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const ModalFooter = props => (
  <div className={styles.nurtureModalFooter}>
    {props.children}
  </div>
);

export default ModalFooter;

ModalFooter.propTypes = {
  children: PropTypes.node.isRequired,
};
